<div class="person-image profile-image-container profile-image-container-{{ imageSize }}"
     [ngClass]="[containerClass]">
    @switch (!!person) {
        @case (true) {
            @if (person?.imageIdentifier) {
                <adapt-storage-image [imageIdentifier]="person?.imageIdentifier"
                                     [defaultImageSrc]="defaultImageSrc"> </adapt-storage-image>
            }
            @if (!person?.imageIdentifier) {
                <adapt-person-default-image [imageSize]="imageSize"
                                            [person]="person"></adapt-person-default-image>
            }
        }
        @default {
            <i class="unknown-person-profile-image fal fa-question"
               aria-hidden="true"></i>
        }
    }
</div>

@if (disabled) {
    <div class="disabled-curtain"></div>
}
